var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 1280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.24099331 -0.00424107 1.24099331 -0.00424107 2.50705719 -0.00856781 C6.90347088 -0.02346276 11.2998527 -0.03274786 15.69628906 -0.03710938 C19.24847933 -0.04145151 22.80042087 -0.05519001 26.35253906 -0.078125 C49.85516291 -0.22666317 72.96473281 0.57454017 96.328125 3.203125 C97.27109436 3.30790161 98.21406372 3.41267822 99.18560791 3.52062988 C104.0602205 4.07544066 108.91292352 4.72805185 113.765625 5.453125 C114.46561615 5.55605865 115.1656073 5.65899231 115.8868103 5.76504517 C158.46118685 12.05780863 199.78708893 22.83047805 240.328125 37.203125 C240.96862793 37.42873108 241.60913086 37.65433716 242.26904297 37.88677979 C281.66739553 51.77574825 319.77878484 70.29112854 355.328125 92.203125 C356.16021484 92.71472168 356.99230469 93.22631836 357.84960938 93.75341797 C384.33384327 110.10126242 409.60494192 128.36621694 433.2578125 148.6015625 C436.00546545 150.94570201 438.81612728 153.20195816 441.640625 155.453125 C446.12889673 159.11906221 450.3942363 162.97376446 454.6171875 166.94140625 C455.31061752 167.5925087 456.00404755 168.24361115 456.7184906 168.91444397 C464.02576153 175.8105096 471.1561174 182.8795737 478.24975586 189.99438477 C480.41730142 192.16736835 482.59025 194.33484863 484.76367188 196.50195312 C486.17219627 197.91113729 487.580411 199.32063106 488.98828125 200.73046875 C489.6237941 201.36395737 490.25930695 201.99744598 490.91407776 202.65013123 C495.24855448 207.00706098 499.32450383 211.54177811 503.328125 216.203125 C504.3014324 217.32087965 505.27527986 218.43816459 506.25 219.5546875 C512.67089748 226.96772226 518.84119204 234.53278038 524.84033203 242.29003906 C526.42723722 244.33056894 528.03068482 246.35730939 529.63671875 248.3828125 C551.58123972 276.1516181 570.46948643 306.11117196 587.328125 337.203125 C588.00633301 338.44666748 588.00633301 338.44666748 588.69824219 339.71533203 C604.47933656 368.79010402 617.25708131 399.05773406 628.328125 430.203125 C628.56446655 430.86640808 628.80080811 431.52969116 629.04431152 432.21307373 C652.07221112 497.11006817 662.99682159 566.34433992 662.71923828 635.08007812 C662.70214776 639.34823353 662.71233578 643.61582724 662.72956085 647.88396358 C662.80559136 670.14747484 661.79034806 692.07373331 659.328125 714.203125 C659.22352966 715.1479071 659.11893433 716.09268921 659.01116943 717.06610107 C658.45631678 721.9388501 657.80292279 726.78976643 657.078125 731.640625 C656.92372452 732.69061172 656.92372452 732.69061172 656.76620483 733.7618103 C650.47344137 776.33618685 639.70077195 817.66208893 625.328125 858.203125 C625.10251892 858.84362793 624.87691284 859.48413086 624.64447021 860.14404297 C610.7625933 899.52227918 592.27778524 937.69709251 570.328125 973.203125 C569.76770508 974.1111084 569.20728516 975.0190918 568.62988281 975.95458984 C553.19143562 1000.84505871 536.21342617 1024.79625031 517.328125 1047.203125 C516.43871286 1048.26685249 515.54939559 1049.3306593 514.66015625 1050.39453125 C509.74305485 1056.25804891 504.75117875 1062.03650898 499.59375 1067.69140625 C498.33816089 1069.08337832 497.08884927 1070.48138443 495.86662292 1071.90274048 C491.46203439 1077.01980923 486.83035515 1081.84702952 482.05078125 1086.61328125 C481.28060165 1087.38441757 480.51042206 1088.15555389 479.71690369 1088.95005798 C478.09871127 1090.56892653 476.47927288 1092.18655051 474.85864258 1093.80297852 C472.39745268 1096.25881218 469.94164691 1098.71993865 467.48632812 1101.18164062 C465.90396633 1102.76334153 464.32129433 1104.34473217 462.73828125 1105.92578125 C461.65197166 1107.01512718 461.65197166 1107.01512718 460.54371643 1108.1264801 C455.96467716 1112.68482711 451.23517098 1117.00128222 446.328125 1121.203125 C445.21022521 1122.17626569 444.09291906 1123.15008935 442.9765625 1124.125 C435.56352774 1130.54589748 427.99846962 1136.71619204 420.24121094 1142.71533203 C418.20068106 1144.30223722 416.17394061 1145.90568482 414.1484375 1147.51171875 C386.3796319 1169.45623972 356.42007804 1188.34448643 325.328125 1205.203125 C324.49909668 1205.65526367 323.67006836 1206.10740234 322.81591797 1206.57324219 C293.74114598 1222.35433656 263.47351594 1235.13208131 232.328125 1246.203125 C231.66484192 1246.43946655 231.00155884 1246.67580811 230.31817627 1246.91931152 C165.42118183 1269.94721112 96.18691008 1280.87182159 27.45117188 1280.59423828 C23.18301647 1280.57714776 18.91542276 1280.58733578 14.64728642 1280.60456085 C-7.61622484 1280.68059136 -29.54248331 1279.66534806 -51.671875 1277.203125 C-52.6166571 1277.09852966 -53.56143921 1276.99393433 -54.53485107 1276.88616943 C-59.4076001 1276.33131678 -64.25851643 1275.67792279 -69.109375 1274.953125 C-70.15936172 1274.79872452 -70.15936172 1274.79872452 -71.2305603 1274.64120483 C-113.80493685 1268.34844137 -155.13083893 1257.57577195 -195.671875 1243.203125 C-196.31237793 1242.97751892 -196.95288086 1242.75191284 -197.61279297 1242.51947021 C-236.99102918 1228.6375933 -275.16584251 1210.15278524 -310.671875 1188.203125 C-311.5798584 1187.64270508 -312.4878418 1187.08228516 -313.42333984 1186.50488281 C-338.31380871 1171.06643562 -362.26500031 1154.08842617 -384.671875 1135.203125 C-385.73560249 1134.31371286 -386.7994093 1133.42439559 -387.86328125 1132.53515625 C-393.72679891 1127.61805485 -399.50525898 1122.62617875 -405.16015625 1117.46875 C-406.55212832 1116.21316089 -407.95013443 1114.96384927 -409.37149048 1113.74162292 C-414.48855923 1109.33703439 -419.31577952 1104.70535515 -424.08203125 1099.92578125 C-424.85316757 1099.15560165 -425.62430389 1098.38542206 -426.41880798 1097.59190369 C-428.03767653 1095.97371127 -429.65530051 1094.35427288 -431.27172852 1092.73364258 C-433.72756218 1090.27245268 -436.18868865 1087.81664691 -438.65039062 1085.36132812 C-440.23209153 1083.77896633 -441.81348217 1082.19629433 -443.39453125 1080.61328125 C-444.48387718 1079.52697166 -444.48387718 1079.52697166 -445.5952301 1078.41871643 C-450.15357711 1073.83967716 -454.47003222 1069.11017098 -458.671875 1064.203125 C-459.64501569 1063.08522521 -460.61883935 1061.96791906 -461.59375 1060.8515625 C-468.01464748 1053.43852774 -474.18494204 1045.87346962 -480.18408203 1038.11621094 C-481.77098722 1036.07568106 -483.37443482 1034.04894061 -484.98046875 1032.0234375 C-506.92498972 1004.2546319 -525.81323643 974.29507804 -542.671875 943.203125 C-543.12401367 942.37409668 -543.57615234 941.54506836 -544.04199219 940.69091797 C-559.82308656 911.61614598 -572.60083131 881.34851594 -583.671875 850.203125 C-584.02638733 849.20820038 -584.02638733 849.20820038 -584.38806152 848.19317627 C-607.41596112 783.29618183 -618.34057159 714.06191008 -618.06298828 645.32617188 C-618.04589776 641.05801647 -618.05608578 636.79042276 -618.07331085 632.52228642 C-618.14934136 610.25877516 -617.13409806 588.33251669 -614.671875 566.203125 C-614.56727966 565.2583429 -614.46268433 564.31356079 -614.35491943 563.34014893 C-613.80006662 558.46739851 -613.14650393 553.61650885 -612.421875 548.765625 C-612.26797302 547.71713379 -612.26797302 547.71713379 -612.11096191 546.64746094 C-601.01820953 471.44518624 -576.46103694 399.35983396 -525.671875 307.203125 C-525.11145508 306.2951416 -524.55103516 305.3871582 -523.97363281 304.45166016 C-508.53518562 279.56119129 -491.55717617 255.60999969 -472.671875 233.203125 C-471.78246286 232.13939751 -470.89314559 231.0755907 -470.00390625 230.01171875 C-465.08680485 224.14820109 -460.09492875 218.36974102 -454.9375 212.71484375 C-453.68191089 211.32287168 -452.43259927 209.92486557 -451.21037292 208.50350952 C-446.80578439 203.38644077 -442.17410515 198.55922048 -437.39453125 193.79296875 C-436.62435165 193.02183243 -435.85417206 192.25069611 -435.06065369 191.45619202 C-433.44246127 189.83732347 -431.82302288 188.21969949 -430.20239258 186.60327148 C-427.74120268 184.14743782 -425.28539691 181.68631135 -422.83007812 179.22460938 C-421.24771633 177.64290847 -419.66504433 176.06151783 -418.08203125 174.48046875 C-417.35782486 173.75423813 -416.63361847 173.02800751 -415.88746643 172.2797699 C-411.30842716 167.72142289 -406.57892098 163.40496778 -401.671875 159.203125 C-400.55397521 158.22998431 -399.43666906 157.25616065 -398.3203125 156.28125 C-390.90727774 149.86035252 -383.34221962 143.69005796 -375.58496094 137.69091797 C-373.54443106 136.10401278 -371.51769061 134.50056518 -369.4921875 132.89453125 C-341.71935194 110.9497621 -311.81632092 91.98529869 -280.671875 75.203125 C-279.38337646 74.50751465 -279.38337646 74.50751465 -278.06884766 73.79785156 C-202.0491193 32.95753814 -117.57500617 8.67303205 -31.671875 1.203125 C-30.66787659 1.11579605 -29.66387817 1.0284671 -28.62945557 0.93849182 C-19.07512309 0.18128995 -9.57719947 0.02259937 0 0 Z ",
    fill: "#151515",
    transform: "translate(617.671875,-0.203125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.91898103 0.00291266 1.83796206 0.00582533 2.78479099 0.00882626 C3.75109943 0.00797024 4.71740788 0.00711422 5.71299839 0.00623226 C8.98751211 0.0045664 12.26197561 0.01011792 15.53648472 0.01555538 C17.90952363 0.01586146 20.28256263 0.01572867 22.6556015 0.01519012 C29.03483617 0.01496352 35.41405224 0.02077708 41.79328251 0.02780056 C47.7700618 0.03347772 53.74683647 0.03376271 59.72361851 0.03447628 C77.2256148 0.03973243 94.72760761 0.05369346 112.22959995 0.06658077 C151.31397495 0.08720577 190.39834995 0.10783077 230.66709995 0.12908077 C230.66709995 78.33908077 230.66709995 156.54908077 230.66709995 237.12908077 C308.54709995 237.12908077 386.42709995 237.12908077 466.66709995 237.12908077 C466.66709995 158.91908077 466.66709995 80.70908077 466.66709995 0.12908077 C525.29366245 0.09814327 525.29366245 0.09814327 585.10459995 0.06658077 C597.46856236 0.05747677 609.83252476 0.04837276 622.57115269 0.03899288 C637.6105814 0.03447628 637.6105814 0.03447628 644.63989353 0.03363705 C649.57402078 0.0327013 654.50813739 0.02893764 659.4422617 0.02350521 C665.72307014 0.01668096 672.00386296 0.01458311 678.28467476 0.0160085 C680.59783456 0.01571014 682.91099487 0.01370673 685.22415149 0.00986564 C688.33259085 0.00494101 691.44096834 0.0060726 694.54940891 0.00882626 C695.46838994 0.00591359 696.38737097 0.00300093 697.33419991 0 C703.55297513 0.01495595 703.55297513 0.01495595 704.66709995 1.12908077 C704.76512478 4.17572272 704.79701194 7.19972306 704.78735447 10.24677181 C704.78821049 11.21308025 704.78906651 12.17938869 704.78994846 13.17497921 C704.79161433 16.44949293 704.7860628 19.72395643 704.78062534 22.99846554 C704.78031927 25.37150445 704.78045206 27.74454345 704.7809906 30.11758232 C704.78121721 36.49681699 704.77540365 42.87603306 704.76838017 49.25526333 C704.76270301 55.23204262 704.76241802 61.20881729 704.76170444 67.18559933 C704.75644829 84.68759562 704.74248726 102.18958843 704.72959995 119.69158077 C704.70897495 158.77595577 704.68834995 197.86033077 704.66709995 238.12908077 C626.45709995 238.12908077 548.24709995 238.12908077 467.66709995 238.12908077 C467.66709995 316.00908077 467.66709995 393.88908077 467.66709995 474.12908077 C545.54709995 474.12908077 623.42709995 474.12908077 703.66709995 474.12908077 C703.66709995 552.33908077 703.66709995 630.54908077 703.66709995 711.12908077 C625.45709995 711.12908077 547.24709995 711.12908077 466.66709995 711.12908077 C466.66709995 633.24908077 466.66709995 555.36908077 466.66709995 475.12908077 C388.78709995 475.12908077 310.90709995 475.12908077 230.66709995 475.12908077 C230.66709995 553.33908077 230.66709995 631.54908077 230.66709995 712.12908077 C172.04053745 712.16001827 172.04053745 712.16001827 112.22959995 712.19158077 C99.86563755 712.20068478 87.50167515 712.20978878 74.76304722 712.21916866 C59.72361851 712.22368526 59.72361851 712.22368526 52.69430637 712.2245245 C47.76017913 712.22546024 42.82606252 712.2292239 37.89193821 712.23465633 C31.61112977 712.24148058 25.33033695 712.24357843 19.04952514 712.24215305 C16.73636535 712.2424514 14.42320504 712.24445481 12.11004841 712.2482959 C9.00160906 712.25322054 5.89323157 712.25208895 2.78479099 712.24933529 C1.86580997 712.25224795 0.94682894 712.25516062 0 712.25816154 C-6.21877522 712.2432056 -6.21877522 712.2432056 -7.33290005 711.12908077 C-7.43092487 708.08243882 -7.46281203 705.05843848 -7.45315456 702.01138973 C-7.45401058 701.04508129 -7.4548666 700.07877285 -7.45574856 699.08318233 C-7.45741442 695.80866861 -7.4518629 692.53420512 -7.44642544 689.25969601 C-7.44611936 686.8866571 -7.44625215 684.51361809 -7.4467907 682.14057922 C-7.4470173 675.76134455 -7.44120374 669.38212848 -7.43418026 663.00289822 C-7.4285031 657.02611893 -7.42821811 651.04934425 -7.42750454 645.07256222 C-7.42224839 627.57056592 -7.40828736 610.06857311 -7.39540005 592.56658077 C-7.37477505 553.48220577 -7.35415005 514.39783077 -7.33290005 474.12908077 C70.87709995 474.12908077 149.08709995 474.12908077 229.66709995 474.12908077 C229.66709995 396.24908077 229.66709995 318.36908077 229.66709995 238.12908077 C151.45709995 238.12908077 73.24709995 238.12908077 -7.33290005 238.12908077 C-7.35352505 199.04470577 -7.37415005 159.96033077 -7.39540005 119.69158077 C-7.40450405 107.32761837 -7.41360806 94.96365597 -7.42298794 82.22502804 C-7.42750454 67.18559933 -7.42750454 67.18559933 -7.42834377 60.15628719 C-7.42927952 55.22215995 -7.43304318 50.28804334 -7.43847561 45.35391903 C-7.44529986 39.07311059 -7.44739771 32.79231777 -7.44597232 26.51150596 C-7.44627068 24.19834616 -7.44827409 21.88518586 -7.45211518 19.57202923 C-7.45703981 16.46358988 -7.45590822 13.35521239 -7.45315456 10.24677181 C-7.45606723 9.32779078 -7.45897989 8.40880976 -7.46198082 7.46198082 C-7.44435082 0.13131698 -7.33066384 0.01763 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(291.33290004730225,283.8709192276001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C77.88 0 155.76 0 236 0 C236 77.88 236 155.76 236 236 C158.12 236 80.24 236 0 236 C0 158.12 0 80.24 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(759,285)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.91898103 0.00291266 1.83796206 0.00582533 2.78479099 0.00882626 C3.75109943 0.00797024 4.71740788 0.00711422 5.71299839 0.00623226 C8.98751211 0.0045664 12.26197561 0.01011792 15.53648472 0.01555538 C17.90952363 0.01586146 20.28256263 0.01572867 22.6556015 0.01519012 C29.03483617 0.01496352 35.41405224 0.02077708 41.79328251 0.02780056 C47.7700618 0.03347772 53.74683647 0.03376271 59.72361851 0.03447628 C77.2256148 0.03973243 94.72760761 0.05369346 112.22959995 0.06658077 C151.31397495 0.08720577 190.39834995 0.10783077 230.66709995 0.12908077 C230.66709995 78.33908077 230.66709995 156.54908077 230.66709995 237.12908077 C308.54709995 237.12908077 386.42709995 237.12908077 466.66709995 237.12908077 C466.66709995 158.91908077 466.66709995 80.70908077 466.66709995 0.12908077 C525.29366245 0.09814327 525.29366245 0.09814327 585.10459995 0.06658077 C597.46856236 0.05747677 609.83252476 0.04837276 622.57115269 0.03899288 C637.6105814 0.03447628 637.6105814 0.03447628 644.63989353 0.03363705 C649.57402078 0.0327013 654.50813739 0.02893764 659.4422617 0.02350521 C665.72307014 0.01668096 672.00386296 0.01458311 678.28467476 0.0160085 C680.59783456 0.01571014 682.91099487 0.01370673 685.22415149 0.00986564 C688.33259085 0.00494101 691.44096834 0.0060726 694.54940891 0.00882626 C695.46838994 0.00591359 696.38737097 0.00300093 697.33419991 0 C703.55297513 0.01495595 703.55297513 0.01495595 704.66709995 1.12908077 C704.76512478 4.17572272 704.79701194 7.19972306 704.78735447 10.24677181 C704.78821049 11.21308025 704.78906651 12.17938869 704.78994846 13.17497921 C704.79161433 16.44949293 704.7860628 19.72395643 704.78062534 22.99846554 C704.78031927 25.37150445 704.78045206 27.74454345 704.7809906 30.11758232 C704.78121721 36.49681699 704.77540365 42.87603306 704.76838017 49.25526333 C704.76270301 55.23204262 704.76241802 61.20881729 704.76170444 67.18559933 C704.75644829 84.68759562 704.74248726 102.18958843 704.72959995 119.69158077 C704.70897495 158.77595577 704.68834995 197.86033077 704.66709995 238.12908077 C626.45709995 238.12908077 548.24709995 238.12908077 467.66709995 238.12908077 C467.66709995 316.00908077 467.66709995 393.88908077 467.66709995 474.12908077 C545.54709995 474.12908077 623.42709995 474.12908077 703.66709995 474.12908077 C703.66709995 474.45908077 703.66709995 474.78908077 703.66709995 475.12908077 C625.78709995 475.12908077 547.90709995 475.12908077 467.66709995 475.12908077 C467.66709995 553.00908077 467.66709995 630.88908077 467.66709995 711.12908077 C467.33709995 711.12908077 467.00709995 711.12908077 466.66709995 711.12908077 C466.66709995 633.24908077 466.66709995 555.36908077 466.66709995 475.12908077 C388.78709995 475.12908077 310.90709995 475.12908077 230.66709995 475.12908077 C230.66709995 553.33908077 230.66709995 631.54908077 230.66709995 712.12908077 C172.04053745 712.16001827 172.04053745 712.16001827 112.22959995 712.19158077 C99.86563755 712.20068478 87.50167515 712.20978878 74.76304722 712.21916866 C59.72361851 712.22368526 59.72361851 712.22368526 52.69430637 712.2245245 C47.76017913 712.22546024 42.82606252 712.2292239 37.89193821 712.23465633 C31.61112977 712.24148058 25.33033695 712.24357843 19.04952514 712.24215305 C16.73636535 712.2424514 14.42320504 712.24445481 12.11004841 712.2482959 C9.00160906 712.25322054 5.89323157 712.25208895 2.78479099 712.24933529 C1.86580997 712.25224795 0.94682894 712.25516062 0 712.25816154 C-6.21877522 712.2432056 -6.21877522 712.2432056 -7.33290005 711.12908077 C-7.43092487 708.08243882 -7.46281203 705.05843848 -7.45315456 702.01138973 C-7.45401058 701.04508129 -7.4548666 700.07877285 -7.45574856 699.08318233 C-7.45741442 695.80866861 -7.4518629 692.53420512 -7.44642544 689.25969601 C-7.44611936 686.8866571 -7.44625215 684.51361809 -7.4467907 682.14057922 C-7.4470173 675.76134455 -7.44120374 669.38212848 -7.43418026 663.00289822 C-7.4285031 657.02611893 -7.42821811 651.04934425 -7.42750454 645.07256222 C-7.42224839 627.57056592 -7.40828736 610.06857311 -7.39540005 592.56658077 C-7.37477505 553.48220577 -7.35415005 514.39783077 -7.33290005 474.12908077 C70.87709995 474.12908077 149.08709995 474.12908077 229.66709995 474.12908077 C229.66709995 396.24908077 229.66709995 318.36908077 229.66709995 238.12908077 C151.45709995 238.12908077 73.24709995 238.12908077 -7.33290005 238.12908077 C-7.35352505 199.04470577 -7.37415005 159.96033077 -7.39540005 119.69158077 C-7.40450405 107.32761837 -7.41360806 94.96365597 -7.42298794 82.22502804 C-7.42750454 67.18559933 -7.42750454 67.18559933 -7.42834377 60.15628719 C-7.42927952 55.22215995 -7.43304318 50.28804334 -7.43847561 45.35391903 C-7.44529986 39.07311059 -7.44739771 32.79231777 -7.44597232 26.51150596 C-7.44627068 24.19834616 -7.44827409 21.88518586 -7.45211518 19.57202923 C-7.45703981 16.46358988 -7.45590822 13.35521239 -7.45315456 10.24677181 C-7.45606723 9.32779078 -7.45897989 8.40880976 -7.46198082 7.46198082 C-7.44435082 0.13131698 -7.33066384 0.01763 0 0 Z M-6.33290005 1.12908077 C-6.33290005 79.00908077 -6.33290005 156.88908077 -6.33290005 237.12908077 C71.54709995 237.12908077 149.42709995 237.12908077 229.66709995 237.12908077 C229.66709995 159.24908077 229.66709995 81.36908077 229.66709995 1.12908077 C151.78709995 1.12908077 73.90709995 1.12908077 -6.33290005 1.12908077 Z M467.66709995 1.12908077 C467.66709995 79.00908077 467.66709995 156.88908077 467.66709995 237.12908077 C545.54709995 237.12908077 623.42709995 237.12908077 703.66709995 237.12908077 C703.66709995 159.24908077 703.66709995 81.36908077 703.66709995 1.12908077 C625.78709995 1.12908077 547.90709995 1.12908077 467.66709995 1.12908077 Z M230.66709995 238.12908077 C230.66709995 316.00908077 230.66709995 393.88908077 230.66709995 474.12908077 C308.54709995 474.12908077 386.42709995 474.12908077 466.66709995 474.12908077 C466.66709995 396.24908077 466.66709995 318.36908077 466.66709995 238.12908077 C388.78709995 238.12908077 310.90709995 238.12908077 230.66709995 238.12908077 Z M-6.33290005 475.12908077 C-6.33290005 553.00908077 -6.33290005 630.88908077 -6.33290005 711.12908077 C71.54709995 711.12908077 149.42709995 711.12908077 229.66709995 711.12908077 C229.66709995 633.24908077 229.66709995 555.36908077 229.66709995 475.12908077 C151.78709995 475.12908077 73.90709995 475.12908077 -6.33290005 475.12908077 Z ",
    fill: "#8E8E8E",
    transform: "translate(291.33290004730225,283.8709192276001)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.33 10 0.66 10 1 C6.7 1 3.4 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(694,1279)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.33 10 0.66 10 1 C6.7 1 3.4 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(576,1279)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.67 10 0.34 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#151515",
    transform: "translate(1279,694)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.67 10 0.34 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#151515",
    transform: "translate(0,694)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.67 10 0.34 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#151515",
    transform: "translate(1279,576)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.67 10 0.34 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#151515",
    transform: "translate(0,576)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.33 10 0.66 10 1 C6.7 1 3.4 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(694,0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.33 10 0.66 10 1 C6.7 1 3.4 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(576,0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(705,1278)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(567,1278)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#151515",
    transform: "translate(1278,705)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#151515",
    transform: "translate(1,705)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#151515",
    transform: "translate(1278,567)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#151515",
    transform: "translate(1,567)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(705,1)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(567,1)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(715,1277)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(559,1277)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(723,1276)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(551,1276)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(730,1275)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(544,1275)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(1275,730)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(4,730)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(1276,723)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(3,723)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#161616",
    transform: "translate(1277,715)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#161616",
    transform: "translate(2,715)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#161616",
    transform: "translate(1277,559)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#161616",
    transform: "translate(2,559)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(1276,551)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(3,551)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(1275,544)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(4,544)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(730,4)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(544,4)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(723,3)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(551,3)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(715,2)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(559,2)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(737,1274)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(538,1274)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(743,1273)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(532,1273)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(749,1272)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(526,1272)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(755,1271)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(760,1270)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(515,1270)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(765,1269)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(510,1269)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1269,765)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(10,765)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1270,760)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(9,760)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1271,755)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(8,755)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1272,749)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(7,749)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1273,743)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(6,743)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1274,737)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(5,737)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1274,538)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(5,538)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1273,532)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(6,532)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1272,526)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(7,526)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1271,520)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(8,520)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1270,515)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(9,515)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(1269,510)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#151515",
    transform: "translate(10,510)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(765,10)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(510,10)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(760,9)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(515,9)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(755,8)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(520,8)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(749,7)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(526,7)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(743,6)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(532,6)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(737,5)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(538,5)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(521,1271)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#161616",
    transform: "translate(770,1268)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#161616",
    transform: "translate(506,1268)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(775,1267)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(501,1267)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(784,1265)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(492,1265)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(788,1264)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(488,1264)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#161616",
    transform: "translate(792,1263)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#161616",
    transform: "translate(484,1263)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(800,1261)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(476,1261)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(804,1260)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(472,1260)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(1083,1103)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1260,804)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(19,804)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1261,800)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(18,800)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1264,788)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(15,788)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1265,784)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(14,784)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1267,775)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(12,775)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1268,770)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(11,770)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1268,506)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(11,506)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1267,501)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(12,501)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1265,492)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(14,492)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1264,488)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(15,488)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1261,476)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(18,476)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(1260,472)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#151515",
    transform: "translate(19,472)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(804,19)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(472,19)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(800,18)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(476,18)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(788,15)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(488,15)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(784,14)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(492,14)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(775,12)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#151515",
    transform: "translate(501,12)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#161616",
    transform: "translate(770,11)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#161616",
    transform: "translate(506,11)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(780,1266)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(497,1266)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(797,1262)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(480,1262)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(808,1259)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(469,1259)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(812,1258)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(465,1258)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(815,1257)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(462,1257)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(819,1256)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(458,1256)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(822,1255)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(455,1255)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(825,1254)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(452,1254)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(832,1252)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(445,1252)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(835,1251)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(442,1251)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(838,1250)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(439,1250)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(841,1249)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(436,1249)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(844,1248)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(433,1248)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(847,1247)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(430,1247)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(850,1246)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(427,1246)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(861,1242)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(416,1242)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(874,1237)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(403,1237)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(879,1235)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(398,1235)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#151515",
    transform: "translate(1085,1101)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#151515",
    transform: "translate(193,1101)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#151515",
    transform: "translate(1101,1085)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#151515",
    transform: "translate(177,1085)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#151515",
    transform: "translate(1101,193)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(178,193)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#151515",
    transform: "translate(1085,177)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(194,177)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(879,44)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(398,44)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(874,42)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(403,42)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(869,40)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(861,37)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(416,37)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(850,33)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(427,33)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(847,32)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(430,32)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(844,31)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(433,31)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(841,30)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(436,30)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(838,29)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(439,29)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(835,28)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(442,28)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(832,27)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(445,27)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(825,25)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(452,25)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(822,24)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(455,24)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(819,23)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(458,23)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(815,22)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(462,22)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(812,21)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(465,21)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(808,20)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(469,20)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(797,17)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#151515",
    transform: "translate(480,17)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(793,16)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(484,16)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(780,13)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#161616",
    transform: "translate(497,13)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(829,1253)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(449,1253)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(853,1245)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(425,1245)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(856,1244)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(422,1244)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(859,1243)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(419,1243)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(864,1241)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(414,1241)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(867,1240)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(411,1240)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(869,1239)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(409,1239)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(872,1238)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(406,1238)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(877,1236)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(401,1236)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(882,1234)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(396,1234)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(884,1233)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(394,1233)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(887,1232)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(391,1232)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(889,1231)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(389,1231)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(894,1229)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(384,1229)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(896,1228)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(382,1228)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(898,1227)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(380,1227)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(901,1226)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(377,1226)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(903,1225)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(375,1225)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(905,1224)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(373,1224)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(907,1223)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(371,1223)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(909,1222)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(369,1222)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(914,1220)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(364,1220)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(362,1219)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(918,1218)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(360,1218)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(920,1217)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(358,1217)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(922,1216)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(356,1216)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(924,1215)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(354,1215)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(926,1214)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(352,1214)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(928,1213)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(350,1213)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(930,1212)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(348,1212)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(932,1211)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(346,1211)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(934,1210)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(344,1210)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(941,1206)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(337,1206)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(943,1205)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(335,1205)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(945,1204)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(333,1204)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(947,1203)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(331,1203)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(952,1200)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(326,1200)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(954,1199)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(324,1199)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(956,1198)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(322,1198)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(959,1196)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(319,1196)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(961,1195)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(317,1195)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(966,1192)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(312,1192)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(971,1189)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(307,1189)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(976,1186)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(302,1186)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(979,1184)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(299,1184)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(984,1181)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(294,1181)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(987,1179)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(291,1179)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(990,1177)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(288,1177)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(993,1175)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(285,1175)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(996,1173)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(282,1173)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(999,1171)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(279,1171)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1002,1169)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(276,1169)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1005,1167)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(273,1167)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1009,1164)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(269,1164)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1012,1162)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(266,1162)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1016,1159)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(262,1159)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1023,1154)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(255,1154)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1032,1147)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(246,1147)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1041,1140)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(237,1140)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1047,1135)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(231,1135)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1053,1130)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(225,1130)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1060,1124)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(218,1124)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(196,1104)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1082,175)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(196,175)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1060,155)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(218,155)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1053,149)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(225,149)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1047,144)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(231,144)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1041,139)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(237,139)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1032,132)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(246,132)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1023,125)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(255,125)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1016,120)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(262,120)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1012,117)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(266,117)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1009,115)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(269,115)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(1005,112)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(273,112)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(1002,110)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(276,110)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(999,108)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(279,108)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(996,106)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(282,106)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(993,104)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(285,104)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(990,102)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(288,102)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(987,100)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(291,100)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(984,98)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(294,98)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(979,95)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(299,95)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(976,93)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(302,93)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(971,90)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(307,90)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(966,87)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(312,87)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(961,84)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(317,84)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(959,83)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(319,83)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(956,81)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(322,81)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(954,80)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(324,80)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(952,79)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(326,79)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(947,76)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(331,76)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(945,75)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(333,75)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(943,74)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(335,74)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(941,73)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(337,73)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(934,69)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(344,69)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(932,68)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(346,68)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(930,67)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(348,67)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(928,66)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(350,66)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(926,65)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(352,65)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(924,64)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(354,64)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(922,63)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(356,63)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(920,62)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(358,62)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(918,61)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(360,61)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(916,60)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(362,60)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(914,59)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(364,59)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(909,57)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(369,57)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(907,56)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(371,56)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(905,55)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(373,55)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(903,54)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(375,54)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(901,53)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(377,53)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(898,52)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(380,52)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(896,51)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(382,51)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(894,50)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(384,50)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(889,48)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(389,48)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(887,47)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(391,47)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(884,46)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(394,46)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(882,45)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(396,45)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(877,43)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(401,43)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(872,41)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(406,41)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(409,40)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(867,39)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(411,39)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(864,38)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(414,38)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(859,36)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(419,36)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(856,35)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#161616",
    transform: "translate(422,35)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(853,34)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(425,34)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(829,26)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#151515",
    transform: "translate(449,26)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#161616",
    transform: "translate(0,0)"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#151515",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/OKX.f1269f84f554b76e4b9cba7f4c1a0335.svg";
export { ForwardRef as ReactComponent };